import { NativeService, StatusBarType } from './../../../services/native.service';
import { MenuService } from 'app/services/menu.service';
import { FieldUpdateModel } from 'app/models/shared/fieldUpdate.model';
import { HttpErrorResponse } from '@angular/common/http';
import { FieldModel } from 'app/models/shared/field.model';

import { FieldGroupModel } from 'app/models/shared/fieldGroup.model';
import { TabModel } from 'app/models/shared/tab.model';

import { Constants } from 'app/utility/constants';
import { BaseComponent } from 'app/base.component';
import { ChangeDetectorRef, AfterViewInit } from '@angular/core';


import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { UserService } from 'app/services/user.service';

import { PopoverController, AlertController, ActionSheetController, LoadingController, Platform } from '@ionic/angular';

import { ActivatedRoute } from '@angular/router';
import { Subscription, Subject, throwError } from 'rxjs';

import { Title } from '@angular/platform-browser';

import { StorageService } from 'app/services/storage.service';

import { trigger, state, style, animate, transition } from '@angular/animations';
import { AfterContentInit } from '@angular/core';
import { StringHelper } from 'app/utility/stringhelper';

@Component({
    selector: 'app-editor-page',
    templateUrl: './editor-page.component.html',
    styleUrls: ['./editor-page.component.scss'],
    animations: [
        trigger('slideUp', [
            transition('void => *', [
                style({ transform: 'translateY(100%)' }),
                animate('500ms ease-out')
            ])
        ]),
        trigger('slideDown', [
            transition('void => *', [
                style({ transform: 'translateY(-100%)' }),
                animate('500ms ease-out')
            ])
        ]),
        trigger('slideRight', [
            transition('void => *', [
                style({ transform: 'translateX(-100%)' }),
                animate('300ms ease-out')
            ])
        ]),
        trigger('slideLeft', [
            transition('void => *', [
                style({ transform: 'translateX(100%)' }),
                animate('300ms ease-out')
            ])
        ])
    ],
    standalone: false
})
export class EditorPageComponent extends BaseComponent implements OnInit, AfterViewInit, AfterContentInit
{
	public id: string;

	activeSegment = 'summary';
	edit = 'summary';
	allowedTabs: any = {};
	allowedEdits: any = {};

	showicons: boolean = false;
	editActive: boolean = false;
	skeleton: boolean = false;
	public saveActivated: boolean = false;

	public subscription: Subscription;
	//add other subscriptions to this via this.subscription.add(subscription);

	public title: string;

	protected eventsSubject: Subject<void> = new Subject<any>();

	public t: string;

	fieldUpdatedSubject: Subject<FieldUpdateModel> = new Subject<FieldUpdateModel>();

	public nativeService: NativeService;
	statusBarColor: StatusBarType;
	previousSegment: string;

	constructor
		(
			public userService: UserService,
			public route: ActivatedRoute,
			public titleService: Title,
			public storage: StorageService,
			public alertController: AlertController,
			public popoverController: PopoverController,
			public actionSheetController: ActionSheetController,
			public loadingController: LoadingController,
			protected cd: ChangeDetectorRef,
			public platform: Platform
		)
	{
		super();
		this.nativeService = this.userService.nativeService;
		this.userService.ping(true);
		this.userService.setRights();
	}

	protected mcOnInit() { }

	public ngOnInit()
	{
		this.skeleton = true;
		this.mcOnInit();
		window.addEventListener('keyboardWillHide', () =>
		{
			const app = document.querySelector('ion-app');
			window.requestAnimationFrame(() =>
			{
				app.style.height = '100%';
				window.requestAnimationFrame(() =>
				{
					app.style.height = '';
				});
			});
		});
	}

	public ngAfterViewInit()
	{
		// console.log("editor-page component ngAfterViewInit");
	}

	public ngAfterContentInit()
	{
		// console.log("editor-page component ngAfterContentInit");
	}


	protected initialiseStatusBar()
	{
		this.statusBarColor = this.nativeService.currentColor;
		var edit = (this.t == "edit" || this.editActive);
		// console.log("editor-page component initialiseStatusBar, ", edit);
		this.nativeService.setupStatusBar(edit ? "dark" : "light");
	}

	protected ionViewWillEnter()
	{
		this.initialiseStatusBar();
	}

	protected ionViewWillLeave()
	{
		// this.nativeService.setupStatusBar(this.statusBarColor);
	}

	public setEdit(active: boolean): void
	{
		this.editActive = active;
		this.nativeService.setupStatusBar(active ? "dark" : "light");
	}

	protected mcOnDestroy() { }
	public ngOnDestroy()
	{
		if (this.subscription)
		{
			if (this.subscription) { this.subscription.unsubscribe(); }
		}
		this.mcOnDestroy();
	}


	setupTitle()
	{
		this.title = this.getHeadingTitle();
	}

	public getHeadingTitle(): string
	{
		return this.getPageName();
	}

	protected mcViewDidEnter() { }
	public ionViewDidEnter()
	{
		let id = this.route.snapshot.paramMap.get('id');
		this.id = id;
		let t = this.route.snapshot.paramMap.get('t');
		if (!t || t == "" || t == null)
		{
			t = this.route.snapshot.queryParamMap.get("t");
		}
		this.t = t;
		// console.log(this.t);

		this.titleService.setTitle(this.titlePrefix + this.getPageName());
		if (id == 'new')
		{
			this.activeSegment = 'general';
			this.fetchTemplate();
		}
		if (this.id != 'new' && this.id != Constants.EmptyGuid)
		{
			// console.debug("editor-page.component.ionViewDidEnter: calling fetchObject");
			this.fetchObject();
		}
		this.mcViewDidEnter();
	}
	titlePrefix: string = "Motorcentral DMS - ";

	public getPageName(): string { return ""; }

	public fetchTemplate() { }

	public fetchObject() { }

	public saveObject() { }

	public cancelEditObject()
	{
		this.setEdit(false);
		this.fetchObject();
	}

	public showEditFab(area = '') { }

	public showAddFab(area = '') { }

	public segmentChanged(ev: any)
	{
		this.previousSegment = this.activeSegment;
		this.activeSegment = ev.detail.value;
		this.setTabHeights();
	}

	public segmentActive(segment)
	{
		return (segment == this.activeSegment); // && this.vehicle
	}

	async presentActionSheet(ev: any, menu: string = '')
	{
		switch (menu)
		{
			default:
				const actionSheet = await this.actionSheetController.create(this.getActionSheet(menu));
				await actionSheet.present();
				actionSheet.onDidDismiss
				break;
		}
	}

	popoverActive: boolean = false;
	async presentPopover(ev: any, menu: string = 'vehicle', additionalProperties: any = null)
	{
		if (this.popoverActive) return;

		this.popoverActive = true;
		const popover = await this.popoverController.create({
			component: this.getPopoverComponent(menu),
			componentProps: {
				menu: menu,
				rights: this.userService.rights,
				additionalProperties: additionalProperties,
			},
			event: ev,
			translucent: true
		});
		await popover.present();
		popover.onDidDismiss().then((data) =>
		{
			this.popoverDismissed(data);
			this.popoverActive = false;
		});
	}

	public popoverDismissed(data: any) { }

	public getActionSheet(menu: any): any { }

	public actionSheetDismissed(data: any) { }

	public getPopoverComponent(menu: string = ''): any { console.log('getPopoverComponent not implemented for this page') }

	async launchEdit()
	{
		if (this.skeleton) return;
		this.setEdit(true);
		this.setupFieldGroups();
		if (this.activeSegment == "summary")
		{
			this.activeSegment = "general";
		}
	}

	async saveModal()
	{
		this.saveActivated = true;
		var errorCount = this.errorFields();

		if (errorCount > 0)
		{
			var message = "There is an error on the form that needs correcting before you can save.";
			if (errorCount > 1)
			{
				message = "There are " + errorCount + " errors that need correcting before you can save.";
			}

			const alert = await this.alertController.create({
				header: "Form Data Error",
				message: message,
				buttons: [
					{
						text: 'OK',
						role: 'cancel',
						cssClass: 'primary',
						handler: () =>
						{
							//do nothing
						}
					}
				]
			});
			await alert.present();
		}
		else if (this.isDirty)
		{
			this.dismissTheModal(true);
		}
		else
		{
			this.dismissTheModal(false); //no need to save
		}
	}

	async dismissTheModal(save: boolean)
	{
		if (save)
		{
			this.syncFormWithObject();
			this.saveObject();
		}
		else
		{
			if (this.id == Constants.EmptyGuid || this.id == "new")
			{
				history.go(-1);
			}
			else
			{
				this.cancelEditObject();
			}
		}
	}

	async cancelModal()
	{
		if (this.isDirty)
		{
			//prompt user to save
			const alert = await this.alertController.create({
				header: "Unsaved changes",
				message: "Are you sure you want to close without saving?",
				buttons: [
					{
						text: 'Cancel',
						role: 'cancel',
						cssClass: 'primary',
						handler: () =>
						{
							return;
						}
					},
					{
						text: 'OK',
						cssClass: 'danger',
						handler: () =>
						{
							this.dismissTheModal(false);
						}
					}
				]
			});

			await alert.present();
		}
		else
		{
			this.dismissTheModal(false);
		}
	}

	public fieldGroupTabs: TabModel[];
	public descriptionFieldGroup: FieldGroupModel[];

	public setupFieldGroups(makeDirty: boolean = false): void
	{
		this.fieldGroupTabs = [];
	}

	public tabVisible(tab: TabModel): boolean
	{
		return (this.editActive) ? tab.canEdit : tab.canView;
	}

	public isDirty: boolean = false;

	public handleFieldChanged(ev: any)
	{
		//console.log('handleFieldChanged', ev);
		this.isDirty = true;
		if (ev.detail && ev.detail.refresh)
		{
			setTimeout(() =>
			{
				this.cd.detectChanges();
			}, 500);
		}
		else
		{
			// console.log(this.activeSegment, this.fieldGroupTabs);
			for (let field_group_tab of this.fieldGroupTabs)
			{
				if (field_group_tab.id == this.activeSegment)
				{
					field_group_tab.handleFieldChanged(ev);

					setTimeout(() =>
					{
						this.cd.detectChanges();
					}, 500);
				}
			}

			if (ev.detail && ev.detail.field && ev.detail.field.hasChildren)
			{
				var payload = new FieldUpdateModel();
				payload.id = ev.detail.field.id;
				this.fieldUpdatedSubject.next(payload);
			}

			this.handleFieldChangedAdditional(ev);
		}
	}

	public handleFieldChangedAdditional(ev: any) { }

	public handleFieldClicked(ev: any) { }

	public errorFields(): number
	{
		var errors: number = 0;
		for (let field_group_tab of this.fieldGroupTabs)
		{
			if (field_group_tab.errorCount)
			{
				console.log("error exists in tab ", field_group_tab.label);
				errors += field_group_tab.errorCount;
			}
		}
		return errors;
	}

	public syncFormWithObject(): boolean
	{
		var data_changed = false;
		// console.log("syncformwithobject");
		for (let field_group_tab of this.fieldGroupTabs)
		{
			// console.log(field_group_tab);
			if (field_group_tab.dirty)
			{
				// console.log("tab is dirty");
				var tab_data_changed = field_group_tab.syncFormWithObject();
				data_changed = (data_changed || tab_data_changed);
				// console.log(field_group_tab);
			}
		}
		return data_changed;
	}

	public tabHasErrors(tab: string)
	{
		if (!this.editActive) return false;
		for (let field_group_tab of this.fieldGroupTabs)
		{
			if (field_group_tab.id == tab)
			{
				return field_group_tab.errorsExist;
			}
		}
		return false;
	}

	public objectLoadError: boolean = false;
	public handleError(error: any, disableShowBack: boolean = false): void
	{
		console.error("handleError", error);
		this.objectLoadError = true;
		this.userService.handleError(error, disableShowBack);
	}

	async presentAlert(title: string, message: string, back: boolean = false)
	{
		this.userService.presentAlert(title, message, back);
	}

	public getFieldGroups(groupId: string): FieldGroupModel[] { return [new FieldGroupModel("")]; }

	public saveIsActivated(): boolean
	{
		return this.saveActivated;
	}


	tabHeight: number = 600;
	protected setTabHeights()
	{
		setTimeout(() =>
		{
			var element = document.getElementById("tabs");
			var content = document.getElementById("content");
			if (element && content)
			{
				var tabHeight = element.offsetHeight;
				var contentHeight = content.offsetHeight;
				if (tabHeight > this.tabHeight)
				{
					this.tabHeight = tabHeight;
				}
				if (contentHeight < this.tabHeight)
				{
					this.tabHeight = contentHeight - 114;
				}
				if (this.tabHeight < 600)
				{
					this.tabHeight = 600;
				}
			}
		}, 0);
	}

	protected async messageBox(title: string, message: string)
	{
		const alert = await this.alertController.create({
			header: title,
			message: message,
			buttons: ['OK']
		});
		await alert.present();
	}

	refreshing: boolean = false;
	async doRefresh(ev: any)
	{
		setTimeout(() =>
		{
			this.fetchObject();
			ev.target.complete();
			this.refreshing = false;
		}, 250);
		this.mcDoRefresh();
	}

	public mcDoRefresh()
	{
	}

	public numberWithCommas(x: any): string
	{
		return StringHelper.numberWithCommas(x);
	}


	scrollTop: boolean = true;;
	ionScrollEvent(ev: any)
	{
		this.scrollTop = ev.detail.scrollTop == 0;
	}
}
